export default __webpack_public_path__ + "js/components/loggedout/parent-creation/teacher-suspected-popup/teacher-image-7c0b9677301f72d9bd8cf440edf558a6.svg";